import { render, staticRenderFns } from "./QuestionImage.vue?vue&type=template&id=8e60a96a&"
import script from "./QuestionImage.vue?vue&type=script&lang=js&"
export * from "./QuestionImage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports